import { Package, Product } from '@vendasta/marketplace-packages';
import { Pipeline } from '@vendasta/sales-common';
import { StageInterface } from '@vendasta/sales-opportunities';
import { DateRange } from '@vendasta/uikit';
import { Observable } from 'rxjs';
import { MultiSelectTag } from '../../filters/tag-selector/tag';
import { PipelineSort } from '../pipeline-sort';
import { PipelineStatuses } from '../pipeline-status-checkbox/pipeline-status-checkbox.service';

import { OpportunityType } from '../../sales-opportunities/interface';

export const PIPELINE_SERVICE_INJECTION_TOKEN = 'PIPELINE_SERVICE_INJECTION_TOKEN';

export interface SalesTeamOptionValue {
  groupId: string;
  teamName: string;
}

export interface SalesPersonOptionValue {
  id: string;
  name: string;
}

export interface PipelineServiceInterface {
  selectedUIFilters$: Observable<PipelineUIFilters>;
  sort$: Observable<PipelineSort>;
  lastSearchTerm$: Observable<string>;
  applySavedFiltersFromStorage(searchTerm: string, filters: PipelineUIFilters, sort: PipelineSort): void;
}

export interface PipelineUIFilters {
  salespeople: SalesPersonOptionValue[];
  salesTeamsIds: SalesTeamOptionValue[];
  salesTeamSalespersonIds: string[];
  packages: Package[];
  products: Product[];
  pipelines: Pipeline[];
  pipelineStage: StageInterface;
  statuses: PipelineStatuses;
  oppTags: MultiSelectTag[];
  acctTags: MultiSelectTag[];
  monthlyRevenueDate: Date;
  expectedClose: DateRange;
  actualClose: DateRange;
  createdDate: DateRange;
  assignedDate: DateRange;
  marketId: string;
  accountGroupId: string;
  types: OpportunityType[];
}
